module.exports = new __parcel__URL__("basic-phrases-words.43926625.jpg").toString();